import actionTypes from '../constants/action-types';
import renderStatuses from '../constants/render-statuses';

const setRenderStatus = (state = renderStatuses.RUNTIME, action) => {
  if (action.type !== actionTypes.SET_RENDER_STATUS) return state;

  return action.payload.status;
};

export default setRenderStatus;
